export const formatNumber = (numberStr: string) => {
  return parseFloat(numberStr).toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};